// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__ZODbl"};